/**
 * Created by kirandogra on 20/07/18.
 */
App.service('driverService',['$http', '$location','API', function ($http, $location,API) {

   this.getVehicleMakeDetails = function(reqObj){

       return API.postWithAccessToken( BASE_URL + '/driver_user_web/get_vehicle_make_details',reqObj);
   }
    this.getVehicleColor = function (reqObj){

        return API.postWithAccessToken( BASE_URL + '/driver_user_web/get_vehicle_make_custom_details',reqObj);
    }
    this.registerVehicle = function(reqObj){

        return API.post( BASE_URL + '/driver_user_web/get_vehicle_make_custom_details',reqObj);
    }
    this.verifyOtp = function(reqObj){

        return API.post( BASE_URL + '/driver_user_web/driver/login',reqObj);
    }
    this.generateOtp = function(reqObj){

        return API.post( BASE_URL + '/driver_user_web/v2/generate_login_otp',reqObj);
    }

    this.updateDriverInfo = function(reqObj){

        return API.postWithAccessToken( BASE_URL + '/driver_user_web/update_driver_info',reqObj);
    }
    this.getVehicleTypes = function(){

        return API.postWithAccessToken( BASE_URL + '/driver_user_web/get_driver_signup_details',{});
    }
    this.fetchDriverDocuments = function(){

        return API.postWithAccessToken( BASE_URL + '/driver_user_web/fetch_required_docs',{});
    }
    this.uploadDocuments = function(formData){

        return API.uploadImagePostRequest( BASE_URL + '/driver_user_web/upload_document',formData);
    }
    this.uploadDocumentsMetaData = function(formData){

        return API.postWithAccessToken( BASE_URL + '/driver_user_web/upload_document',formData);
    }
    this.deleteDocument = function(reqObj){

        return API.postWithAccessToken( BASE_URL + '/driver_user_web/delete_document',reqObj);
    }
    this.completeRegisteration = function(reqObj){

        return API.postWithAccessToken( BASE_URL + '/driver_user_web/verify_document_status',reqObj);
    }
}]);